import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import CachedOutlinedIcon from '@material-ui/icons/CachedOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import ReplayOutlinedIcon from '@material-ui/icons/ReplayOutlined';

import classes from './Loading.scss';

function reloadPage() {
  window && window.location.reload();
}

const SPINNER_DELAY = 300;

export default function Loading({ error = null, retry = null, ...rest }) {
  const { t } = useTranslation(['main']);
  const [pastDelay, setPastDelay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setPastDelay(true), SPINNER_DELAY);

    return () => {
      clearTimeout(timer);
    };
  }, [setPastDelay]);

  if (error) {
    return (
      <div className={classes.container}>
        <div className={classes.inner}>
          <Typography variant="body1" color="error" paragraph>
            <ErrorOutlineOutlinedIcon className={classes.errorIcon} />
            {' '}
            {t('loadingError')}
          </Typography>
          <Typography variant="body1" paragraph>
            {retry ? (
              <Button
                className = {classes.button}
                variant   = "contained"
                color     = "primary"
                onClick   = {retry}
                startIcon = {<ReplayOutlinedIcon />}
              >
                {t('buttons.retry')}
              </Button>
            ) : null}
            <Button
              className = {classes.button}
              variant   = "text"
              onClick   = {reloadPage}
              startIcon = {<CachedOutlinedIcon />}
            >
              {t('reloadPage')}
            </Button>
          </Typography>
        </div>
      </div>
    );
  }

  if (pastDelay) {
    return (
      <div className={classes.container}>
        <div className={classes.inner}>
          <Typography variant="body1" component="div" paragraph>
            <CircularProgress />
          </Typography>
          <Typography variant="body1" paragraph>
            {t('loading')}
          </Typography>
        </div>
      </div>
    );
  }

  return null;
}
